<div class="modal-content">
    <div class="modal-title">
        <div class="title-container d-flex justify-content-center">
            <h2 class="title-modal">Alterar Dados Bancários</h2>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col-sm-12">
            <form [formGroup]="formDadosBancarios" class="form-box p-5">
                <fieldset>
                    <legend>Dados Bancários para depósito</legend>
                    <small>Informe abaixo os dados da conta para depósito da garantia</small>
                    <div class="form-row mt-3">
                        <div class="form-group col-sm-12">
                            <label class="form-label">Banco para depósito</label>
                            <select formControlName="bancoId" class="form-control custom-input" (change)="onBancoChange($event.target.value)">
                                <option value="">Selecione uma das opções para prosseguir</option>
                                <option *ngFor="let banco of tableBancos" [value]="banco.id">{{banco.nome}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-sm-12 col-md-4">
                            <label class="form-label">Tipo de Conta *</label>
                            <select formControlName="tpConta" class="form-control custom-input">
                                <option value="">Selecione uma das opções</option>
                                <option value="corrente">Conta Corrente</option>
                                <option value="poupanca">Conta Poupança</option>
                            </select>
                        </div>
                        <div class="form-group col-sm-12 col-md-4">
                            <label class="form-label">Agência *</label>
                            <input maxlength="5" type="text" formControlName="agencia" class="form-control custom-input" mask="0000">
                        </div>
                        <div *ngIf="banco.value == '001'" class="form-group col-sm-12 col-md-4">
                            <label class="form-label">Dígito Agência *</label>
                            <input maxlength="2" type="text" formControlName="dgAgencia" class="form-control custom-input" maxlength="1">
                        </div>
                        <div class="form-group col-sm-12 col-md-4">
                            <label class="form-label">Conta *</label>
                            <input maxlength="12" type="text" formControlName="conta" class="form-control custom-input" (input)="validateDataBank($event)">
                        </div>
                        <div class="form-group col-sm-12 col-md-4">
                            <label class="form-label">Dígito *</label>
                            <input maxlength="2" type="text" formControlName="dgConta" class="form-control custom-input" maxlength="1">
                        </div>
                    </div>
                </fieldset>
            </form>
            <div class="row d-flex justify-content-center mt-5">
                <button (click)="closeModal()" class="btn mr-5">Voltar</button>
                <button (click)="updateDados()" class="btn">Concluir</button>
            </div>
        </div>
    </div>
</div>
